const bubble14 = (color) => `
<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="421.186 747.085 60 60"><g data-name="Group 36"><path d="M421.186 777.085c0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.568-13.432 30-30 30-16.569 0-30-13.432-30-30Z" fill="${color}" fill-rule="evenodd" data-name="Ellipse 1"/><g data-name="Group 9"><path d="M463.186 762.085h-24c-1.655 0-3 1.345-3 3v18c0 1.654 1.345 3 3 3h4.5v5.649l9.415-5.649h10.085c1.654 0 3-1.346 3-3v-18c0-1.655-1.346-3-3-3Zm0 21H452.27l-5.584 3.351v-3.351h-7.5v-18h24v18Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/><path d="M458.686 774.085a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM449.686 774.085a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="#f5f5f5" fill-rule="evenodd" data-name="Vector"/></g></g></svg>
`;
export default bubble14;



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble14.js
// module id = null
// module chunks = 